import { render } from "./ClusterPermissionsEditor.vue?vue&type=template&id=1c83ff05&scoped=true"
import script from "./ClusterPermissionsEditor.vue?vue&type=script&lang=js"
export * from "./ClusterPermissionsEditor.vue?vue&type=script&lang=js"

import "./ClusterPermissionsEditor.vue?vue&type=style&index=0&id=1c83ff05&lang=scss&scoped=true"

import exportComponent from "../../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c83ff05"]])

export default __exports__